export const env: any = {
  appSheet: {
    url: process.env.REACT_APP_APPSHEET_URL,
    timeout: process.env.REACT_APP_APPSHEET_TIME_OUT
  },
  googleMap: {
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY
  },
  googleCaptcha: {
    siteKey: process.env.REACT_APP_SITE_KEY
  },
  modalConfig: {
    enabled: process.env.REACT_APP_MODAL_ENABLED === 'true',
    endDate: process.env.REACT_APP_MODAL_END_DATE || '',
    imageUrl: process.env.REACT_APP_MODAL_IMAGE_URL || '',
    redirectUrl: process.env.REACT_APP_MODAL_REDIRECT_URL || ''
  }
};

